<template>
  <section>
    <v-row class="mb-6">
      <v-col
        lg="6"
        md="4"
      >
        <h1 class="fiscalization-title">
          Фискализация
        </h1>
      </v-col>
      <v-col
        lg="6"
        md="8"
        class="d-flex justify-sm-end"
      >
        <v-btn
          v-if="userCanPrintXreport"
          class="mr-3"
          color="gray"
          :loading="printReportLoading"
          depressed
          large
          @click="printReportDialog = true"
        >
          <font-awesome-icon
            size="lg"
            class="mr-2"
            icon="print"
          />
          Печать X-отчета
        </v-btn>
      </v-col>
    </v-row>
    <cash-box-history :date="selectedDate" />
    <primary-confirm-dialog
      v-model="printReportDialog"
      title="Вы действительно хотите распечатать Х-отчет?"
      :loading="printReportLoading"
      close-after-loading
      @confirm="printXReport"
    >
      <template
        v-if="printReportDialogSubtitle"
        #subtitle
      >
        <font-awesome-icon
          class="mr-1"
          icon="exclamation-triangle"
        />
        {{ printReportDialogSubtitle }}
      </template>
    </primary-confirm-dialog>
  </section>
</template>
<script>
  import { mapGetters } from 'vuex'
  import CashBoxHistory from './CashBoxHistory.vue'
  import printApi from '@/api/print'
  import snackbarMessage from '@/mixins/snackbar-message'
  import PrimaryConfirmDialog from '@/components/ui/dialogs/PrimaryConfirmDialog.vue'
  import moment from 'moment'
  import permissions from '@/mixins/permissions'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'

  export default {
    name: 'Fiscalization',
    components: { CashBoxHistory, PrimaryConfirmDialog },
    mixins: [snackbarMessage, permissions],
    data () {
      return {
        printReportLoading: false,
        printReportDialog: false,
      }
    },
    computed: {
      ...mapGetters({
        localStorageBranch: 'branches/getLocalStorageBranch',
        selectedDate: 'orders/getSelectedDate',
      }),
      isCurrentDate () {
        return this.selectedDate === moment().format('YYYY-MM-DD')
      },
      printReportDialogSubtitle () {
        return this.isCurrentDate
          ? null
          : `Отчет будет распечатан за текущий день (${moment().format('DD.MM.YYYY')})`
      },
      userCanPrintXreport () {
        return this.userCan(CRMPermission.XReport)
      },
    },
    methods: {
      async printXReport () {
        if (!this.userCanPrintXreport) {
          this.showErrorMessage('Доступ запрещен')
          return
        }

        this.printReportLoading = true
        try {
          await printApi.printXReport(this.localStorageBranch.id)
          this.printReportDialog = false
        } catch (e) {
          this.showErrorFromResponse(e)
        } finally {
          this.printReportLoading = false
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.fiscalization-title {
  font-size: 24px;
  font-weight: 500;
}
</style>
